import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { HrmWorkCalendar } from "../../../models/hrm-work-calendar.model";

@Component({
  selector: "ngx-hrm-work-calendar-form",
  templateUrl: "./hrm-work-calendar-form.component.html",
  styleUrls: ["./hrm-work-calendar-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HrmWorkCalendarFormComponent extends BaseFormComponent<HrmWorkCalendar> {
  public apiName: string = "HrmWorkCalendar";
  public label: string = "جدول تقویم کاری";
  DefaultValues: Dictionary = [];
  HrmWorkCalendarDetails: form_control[];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.DefaultValues["HrmWorkCalendarId"] = 0;
    super.ngOnInit();
  }
  setdefault() {
    if (!this.model.HrmWorkCalendarDetails) this.model.HrmWorkCalendarDetails = [];
    if (!this.model.DayBase) this.model.DayBase = 440;
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.DefaultValues = undefined;
    this.HrmWorkCalendarDetails = undefined;
  }
  setColumnAttribute(): void {
    super.setColumnAttribute();
    this.HrmWorkCalendarDetails = this.getDetailControlModels("HrmWorkCalendarDetails");
  }
  valueChanges($event) {
    if ($event && $event.controls["DayNum"]?.value && this.formGroup.controls["DayBase"]?.value) {
      $event.get("DayMM").setValue($event.controls["DayNum"].value * this.formGroup.controls["DayBase"].value);
    }
  }
}
